<template>
    <div>
        <modal
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            title="Новый бренд"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            <form @submit.prevent="saveModal">
                <div class="cabinet-form-group">
                    <label
                        class="cabinet-form-group__label required"
                        for="brand_name"
                        >Название бренда</label
                    >
                    <input
                        id="brand_name"
                        v-model="BrandName"
                        type="text"
                        class="cabinet-form-group__input"
                        :class="{
                            error:
                                ($v.BrandName.$dirty &&
                                    $v.BrandName.$invalid) ||
                                errors.createBrand.BrandName
                        }"
                    />
                    <div
                        v-if="$v.BrandName.$dirty && $v.BrandName.$invalid"
                        class="error-label"
                    >
                        Поле обязательно для заполнения
                    </div>
                    <div
                        v-if="
                            errors.createBrand.BrandName && !$v.BrandName.$dirty
                        "
                        class="error-label"
                    >
                        {{ errors.createBrand.BrandName[0] }}
                    </div>
                </div>
            </form>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import { required, maxLength } from 'vuelidate/lib/validators'
import { mapState, mapActions } from 'vuex'

const validations = {
    BrandName: {
        required,
        maxLength: maxLength(150)
    }
}

export default {
    name: 'CreateBrand',
    components: { Modal },
    props: {
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            BrandName: ''
        }
    },
    computed: {
        ...mapState('user', ['user']),
        ...mapState('supplierBrand', ['errors'])
    },
    validations,
    methods: {
        ...mapActions('supplierBrand', ['createBrand']),
        closeModal() {
            this.$emit('closeModal')
        },
        async saveModal() {
            if (this.loading) return

            this.$v.$touch()
            if (!this.$v.$invalid) {
                this.$v.$reset()
                this.loading = true

                let data = {
                    BrandName: this.BrandName,
                    Phones: [this.user.phone],
                    Email: this.user.email,
                    WWW_Site: this.user.website
                }

                await this.createBrand(data)

                if (Object.keys(this.errors.createBrand).length) {
                    this.$notify({
                        type: 'error',
                        text: this.errors.createBrand.error
                    })
                } else {
                    this.BrandName = ''
                    this.$emit('createBrandSaved')
                }

                this.loading = false
            } else {
                console.log('Form not valid')
            }
        }
    }
}
</script>
